import { DBOperation, DataStatus } from '../Shared/enum';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
//import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { Injectable } from '@angular/core';
import { User } from '../Models/FitnessBox/User';
import { Organisation } from '../Models/Common/Organisation';
import { Screen } from '../Models/Screen';
import { ApplicationConfiguration } from '../Models/ApplicationConfiguration';

export interface IComponent {
  total: number;
  msg: string;
  dataStatus: DataStatus;
  dbops: DBOperation;
  perPage: number;
  pageNum: number;
  modal: NgxSmartModalService;
  loading: boolean;
  indLoading: boolean;
  isDataRefreshed: boolean;
  filter: string;
  sortData: string;
  Load(perpage: number, pn: number, rowsToCache: number): void;
  add(): void;
  edit(id: number): void;
  delete(id: number): void;
}

export interface IData {
  RowNumber: number
}


export class CommonData {
  RowNumber: number
}

export interface IServerResponse {
  items: any[];
  total: number;
}

export interface IService {
  get(url: string): Observable<any>;
  getData(url: string): Promise<any>;
  post(url: string, model: any): Observable<any>;
  post(url: string, args: any[]): Observable<any>;
  put(url: string, id: number, model: any): Observable<any>;
  delete(url: string, id: number): Observable<any>;

}

export interface IQuickSearchable {
  Name: string;
  ID: number;
  IsActive: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AppContext {
  private _currentOrg: Organisation;
  private _currentUser: User;

  // ✅ Add observables to notify components of changes
  private currentOrgSubject = new BehaviorSubject<Organisation | null>(null);
  private currentUserSubject = new BehaviorSubject<User | null>(null);

  public currentOrgChanged = this.currentOrgSubject.asObservable();
  public currentUserChanged = this.currentUserSubject.asObservable();

  public AppConfigurations: ApplicationConfiguration;
  public CurrentScreen: any;

  constructor() { }

  /**
   * Getter for CurrentOrg
   */
  get CurrentOrg(): Organisation {
    return this._currentOrg;
  }

  /**
   * Setter for CurrentOrg - also emits change notification
   */
  set CurrentOrg(value: Organisation) {
    this._currentOrg = value;
    this.currentOrgSubject.next(value);
  }

  /**
   * Getter for CurrentUser
   */
  get CurrentUser(): User {
    return this._currentUser;
  }

  /**
   * Setter for CurrentUser - also emits change notification
   */
  set CurrentUser(value: User) {
    this._currentUser = value;
    this.currentUserSubject.next(value);
  }
}
